import { ref } from 'vue';

/**
 * Module-level so the state survives unmounting of the wallet button that started the payment:
 * creating the order empties the shopping cart, which unmounts the button (and anything rendered
 * inside it) while the gateway init/fingerprint/process requests are still running. The spinner
 * bound to this state is rendered globally in App.vue.
 */
const processing = ref(false);

export const useWalletPayProcessing = () => {
  return {
    processing,
  };
};
